<template>
  <div class="draft-list">
    <template v-if="isLoading">
      <el-card v-for="i in 3" :key="i" class="draft-card" shadow="hover">
        <el-skeleton animated>
          <template slot="template">
            <el-skeleton-item variant="h3" style="width: 50%" />
            <div
              v-for="i in 3"
              :key="i"
              style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px"
            >
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="width: 30%" />
            </div>

            <el-skeleton-item variant="h1" style="margin-top: 16px; width: 100%; height: 32px" />
          </template>
        </el-skeleton>
      </el-card>
    </template>

    <template v-else>
      <el-card v-for="(item, index) in scripts" :key="index" class="draft-card" shadow="hover">
        <div class="draft-title">方案 {{ index + 1 }}：{{ item.title }}</div>
        <div class="draft-content">
          <p v-for="(shot, index) in item.shots" :key="index">
            <span>{{ shot.time_range }}</span>
            <span>{{ shot.visual_core }}</span>
          </p>
        </div>

        <div class="draft-info">
          <span class="el-icon-time">&ensp;{{ item.duration }}秒</span>
          <span class="el-icon-camera">&ensp;{{ item.shot_count }}个分镜</span>
        </div>

        <el-button style="width: 100%; margin-top: 10px" icon="el-icon-search" @click="showDetail(item)">查看详情</el-button>
      </el-card>
    </template>

    <el-dialog title="脚本详情" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
      <el-table :data="tableData" class="common-el-table-styles" border style="width: 100%">
        <el-table-column label="NO." width="60">
          <template slot-scope="{ $index }">{{ $index + 1 }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="time_range" label="时间区间" width="120"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="shot_title" label="分镜标题"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="visual_core" label="画面描述"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="dialogue" label="台词"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="content_narrative_focus" label="叙事重点"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="emotion_atmosphere" label="情感氛围"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="keywords" label="关键要素"> </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="onDialogClose">关闭</el-button>
        <el-button type="primary" @click="onEdit">以此为基础进行编辑</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import store from '@/store'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router/composables'
const router = useRouter()
const dataList = [
  {
    duration: 15,
    shot_count: 4,
    title: '悬疑反转风',
    shots: [
      {
        key_elements: ['悬念', '反转', '神秘'],
        shot_title: '神秘男子登场',
        time_range: '00:00-00:05',
        dialogue: '无',
        visual_core:
          '画面中，一名穿着深色西装的男子站在昏暗的街道上，背对镜头，缓慢转身露出一张充满谜团的脸。他的身后是一辆亮着车灯的豪华轿车，周围弥漫着薄雾。',
        emotion_atmosphere: '神秘、紧张',
        content_narrative_focus: '通过悬念式的开场，吸引观众的好奇心，暗示即将揭晓一个引人入胜的故事。'
      },
      {
        key_elements: ['线索', '调查', '真相'],
        shot_title: '关键线索浮现',
        time_range: '00:05-00:10',
        dialogue: '无',
        visual_core:
          '镜头切换到室内，男子坐在办公桌前，手中拿着一份文件。他突然停下，抬头看向窗外，眼神中闪过一丝惊讶。桌上散落着几张照片和一支笔。',
        emotion_atmosphere: '专注、疑惑',
        content_narrative_focus: '展示主角正在调查某个重要事件，为后续剧情铺垫。'
      },
      {
        key_elements: ['科学', '突破', '发现'],
        shot_title: '高潮时刻到来',
        time_range: '00:10-00:13',
        dialogue: '无',
        visual_core:
          '画面切换到一个实验室场景，男子与一位科学家正在激烈讨论。科学家指着屏幕上的数据，男子则显得非常激动，似乎发现了惊人的秘密。',
        emotion_atmosphere: '紧张、兴奋',
        content_narrative_focus: '揭示故事的核心冲突或关键信息，推动剧情发展。'
      },
      {
        key_elements: ['品牌', '行动', '探索'],
        shot_title: '行动召唤',
        time_range: '00:13-00:15',
        dialogue: '无',
        visual_core: '画面定格在男子坚定的眼神上，背景逐渐模糊，出现品牌标志和标语。最后，屏幕上显示“立即探索更多”的字样。',
        emotion_atmosphere: '激励、期待',
        content_narrative_focus: '引导观众采取行动，完成广告的最终目的。'
      }
    ]
  },
  {
    duration: 15,
    shot_count: 4,
    title: '情感共鸣风',
    shots: [
      {
        key_elements: ['家庭', '幸福', '温暖'],
        shot_title: '温馨家庭场景',
        time_range: '00:00-00:05',
        dialogue: '无',
        visual_core:
          '画面中，一个幸福的家庭正在厨房里准备晚餐。母亲微笑着搅拌锅里的食物，父亲在旁边帮忙洗菜，两个孩子在餐桌旁玩耍，整个房间充满了欢声笑语。',
        emotion_atmosphere: '温馨、快乐',
        content_narrative_focus: '通过展现家庭的温暖和幸福，引发观众的情感共鸣。'
      },
      {
        key_elements: ['危机', '保护', '安全'],
        shot_title: '意外发生',
        time_range: '00:05-00:10',
        dialogue: '无',
        visual_core: '突然，厨房的窗户被一阵强风吹开，窗帘飘动，灯光闪烁。母亲惊慌地抱起孩子，父亲迅速关闭燃气阀门，场面变得紧张起来。',
        emotion_atmosphere: '紧张、担忧',
        content_narrative_focus: '制造冲突，让观众感受到危机的存在，增加戏剧性。'
      },
      {
        key_elements: ['智能', '安全', '可靠'],
        shot_title: '解决方案出现',
        time_range: '00:10-00:13',
        dialogue: '无',
        visual_core: '画面切换到产品特写，一款智能安防设备安装在窗户上。当强风吹来时，设备自动关闭并发出提示音，确保家庭的安全。',
        emotion_atmosphere: '安心、信任',
        content_narrative_focus: '展示产品的功能和优势，解决之前的危机。'
      },
      {
        key_elements: ['品牌', '安全', '家庭'],
        shot_title: '行动召唤',
        time_range: '00:13-00:15',
        dialogue: '无',
        visual_core: '画面回到温馨的家庭场景，全家人都松了一口气，脸上露出了笑容。最后，屏幕上显示“守护每一个家”的标语。',
        emotion_atmosphere: '感动、信赖',
        content_narrative_focus: '强化品牌理念，鼓励观众购买产品以保障家庭安全。'
      }
    ]
  },
  {
    duration: 15,
    shot_count: 4,
    title: '幽默搞笑风',
    shots: [
      {
        key_elements: ['荒诞', '幽默', '日常'],
        shot_title: '荒诞日常',
        time_range: '00:00-00:05',
        dialogue: '无',
        visual_core:
          '画面中，一名男子正在超市购物，他推着购物车，嘴里念叨着‘今天一定要买这个’。当他走到货架前时，突然停住了脚步，眼睛瞪得大大的，仿佛看到了什么不可思议的东西。',
        emotion_atmosphere: '搞笑、轻松',
        content_narrative_focus: '通过夸张的表演和荒诞的情节，吸引观众的注意力。'
      },
      {
        key_elements: ['玩具', '惊喜', '笑点'],
        shot_title: '意外惊喜',
        time_range: '00:05-00:10',
        dialogue: '无',
        visual_core:
          '男子终于鼓起勇气拿起货架上的商品，但当他拿到手里时，却发现这是一个巨大的充气玩具。他愣住了，随后忍不住笑了出来，周围的人都投来了好奇的目光。',
        emotion_atmosphere: '欢乐、搞笑',
        content_narrative_focus: '制造笑点，让观众感受到产品的趣味性和独特性。'
      },
      {
        key_elements: ['产品', '设计', '功能'],
        shot_title: '产品展示',
        time_range: '00:10-00:13',
        dialogue: '无',
        visual_core: '画面切换到产品的特写镜头，展示其独特的设计和功能。男子抱着充气玩具走出超市，脸上洋溢着满足的笑容。',
        emotion_atmosphere: '愉悦、轻松',
        content_narrative_focus: '突出产品的特点，让观众记住品牌。'
      },
      {
        key_elements: ['品牌', '尝试', '乐趣'],
        shot_title: '行动召唤',
        time_range: '00:13-00:15',
        dialogue: '无',
        visual_core: '画面定格在男子开心的表情上，背景逐渐模糊，出现品牌标志和标语。最后，屏幕上显示“快来试试吧！”的字样。',
        emotion_atmosphere: '兴奋、期待',
        content_narrative_focus: '激发观众的购买欲望，引导他们尝试产品。'
      }
    ]
  }
]
// eslint-disable-next-line
const props = defineProps({
  scripts: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean
  }
})

const dialogVisible = ref(false)
const tableData = ref([])
const currRow = ref([])

const isLoading = computed(() => props.loading)

function showDetail(row) {
  dialogVisible.value = true
  tableData.value = row?.shots.map((s) => ({ ...s, keywords: s.key_elements.join('、') })) || []
  currRow.value = row
}

function onDialogClose() {
  dialogVisible.value = false
}
function onEdit() {
  router.push({ name: 'materialscriptedit', params: { scriptContent: currRow.value, scriptId: `${Date.now()}` } })
  currRow.value = null
  onDialogClose()
}
</script>

<style scoped lang="scss">
.draft-list {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  .draft-card {
    .draft-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 6px;
    }
    .draft-content {
      color: #606266;
      line-height: 1.6;
      height: 90px;
      overflow: auto;
    }
    .draft-info {
      margin-top: 10px;
      display: flex;
      background-color: #f9f9f9;
      align-content: center;
      justify-content: space-between;
      padding: 6px 2px;
    }
  }
}
</style>
